/**------------------------------------------------------
 * Validation Issue (can be nested!)
 */
export interface IValidatorError {
	property	: string;								// object's property that haven't pass validation, in case of an array the index
	value		: any;									// value that haven't pass a validation
	errors		: string[];								// error messages of constraints that failed validation
	children	: IValidatorError[];
}
